import { ReportFilterModel } from './../models/report-filter.model';
import { NgModel } from '@angular/forms';
import { ApplicationRouteURL, IKeyValueInterface, DataListModel, WeGoConfig, RoleLevel } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit } from '@angular/core';
import { RevenuePerVehicleReportService } from "../models/revenue-per-vehicle.service";

@Component({
  selector: 'wego-revenue-per-vehicle-report',
  template: require('../views/revenue-per-vehicle.component.html'),
  providers: [RevenuePerVehicleReportService],
  styles: [`
          .box-body{
            padding: 0px 10px 10px;
          }
          .checkbox-inline{
            padding-left: 0px !important;
          }         
          `
  ]
})
export class RevenuepervehicleReportComponent implements OnInit {
  itemPerPageList: number[];
  itemsPerPage: number;
  apiErrorMsg: any;
  urlDefaultPage: any;
  isLoading: boolean;
  isValidSearch: boolean = false;
  errorModel: IKeyValueInterface[];
  reportName: string;
  revenuPerVehicleList: any[];
  DataListModel: DataListModel;
  public listOfFilterRecord: any[];
  roleLevel = RoleLevel;

  constructor(private authService: AuthService
    , private revenuePerVehicleReportService: RevenuePerVehicleReportService) {
  }

  ngOnInit() {
    this.reportName = "Revenue_Per_Vehicle_Report";
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.DataListModel = new DataListModel();
  }

  public OnSearch($event: any) {
    this.ResetPaging();
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.revenuePerVehicleReportService.GetRevenuePerVehicleList(model).subscribe(
      res => {
        if (res && res.data) {
          this.isValidSearch = res.data.length > 0 ? true : false;
          this.revenuPerVehicleList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.errorModel = [];
        }
        else {
          // Handle No Data
          this.revenuPerVehicleList = [];
          this.isValidSearch = false;
          this.errorModel = res.error;
        }
        this.FilterList();
        this.isLoading = false;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });


  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.itemsPerPage = parseInt(event);
    this.FilterList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }

  public FilterList() {
    let start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + (this.DataListModel.itemsPerPage);
    this.listOfFilterRecord = this.revenuPerVehicleList.slice(start, end);
  }

  public ResetPaging() {
    this.revenuPerVehicleList = [];
    this.listOfFilterRecord = [];
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 10;
  }

  public ResetValidSearch($event: any) {
    let isValidSearch: boolean = $event.isValidSearch;
    this.isValidSearch = isValidSearch;
    this.revenuPerVehicleList = [];
    this.listOfFilterRecord = [];
    this.DataListModel.totalItems = 0;
  }

  public OnExportExcel($event: any) {
    this.isLoading = true;
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.revenuePerVehicleReportService.ExportRevenuePerVehicleReportExcel(model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "RevenuePerVehicle" + new Date().toISOString() + ".xlsx";
          this.authService.DownloadXlsFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnExportPDF($event: any) {
    this.isLoading = true;
    let model: ReportFilterModel = $event.model;
    this.revenuePerVehicleReportService.ExportRevenuePerVehicleReportPDF(model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "RevenuePerVehicle" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/components/revenue-per-vehicle.component.ts